"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingCell = exports.SidebarInfo = exports.SidebarProfilePic = exports.LoadingSidebar = exports.LoadingContent = exports.LoadingMain = exports.ContentInputRow = exports.ContentLabel = exports.ContentText = exports.ContentHeader = exports.LoadingContainer = exports.Container = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
const styled_1 = __importDefault(require("@emotion/styled"));
const styles_1 = require("../Shimmer/styles");
exports.Container = (0, styled_1.default)('div') `
  width: 100%;
  height: 100%;
`;
exports.LoadingContainer = (0, styled_1.default)('div') `
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
`;
exports.ContentHeader = (0, styled_1.default)('div') `
  height: 2rem;
`;
exports.ContentText = (0, styled_1.default)('div') `
  display: flex;
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_medium')};

  width: 70%;
  justify-content: space-between;
  > div {
    width: 47%;
    height: 2rem;
  }
`;
exports.ContentLabel = (0, styled_1.default)('div') `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  height: 2rem;
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  width: 40%;
`;
exports.ContentInputRow = (0, styled_1.default)('div') `
  display: flex;
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  width: 70%;
  justify-content: space-between;
  > div {
    flex: 1 1 auto;
    margin-right: ${(0, ui_theme_1.fromTheme)('spacing_small')};
    height: 2rem;
  }
`;
exports.LoadingMain = (0, styled_1.default)('div') `
  flex: 1 0 auto;
`;
exports.LoadingContent = (0, styled_1.default)('div') `
  width: 50%;
`;
exports.LoadingSidebar = (0, styled_1.default)('div') `
  border-radius: 2px;
  border: 1px solid ${(0, ui_theme_1.fromTheme)('color_background_disabled_form_input')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  width: 25%;
  display: flex;
  align-self: flex-end;
`;
exports.SidebarProfilePic = (0, styled_1.default)('div') `
  width: 25%;
  margin-right: ${(0, ui_theme_1.fromTheme)('spacing_small')};
`;
exports.SidebarInfo = (0, styled_1.default)('div') `
  flex: 1;

  > div {
    width: 100%;
    height: 1.2rem;
    margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')};
    &:last-child {
      width: 80%;
      margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};
    }
  }
`;
exports.LoadingCell = (0, styled_1.default)(styles_1.ShimmerBase) ``;
//# sourceMappingURL=styles.js.map